<template>
  <el-form
    ref="addTask"
    :model="addFrom"
    :rules="rules"
    label-width="120px"
    class="userManage-from"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item label="配置类型" prop="pzlx">
          <el-select
            v-model="addFrom.pzlx"
            placeholder="请选择配置类型"
            filterable
            clearable
            style="width: 100%"
            class="filter-item"
          >
            <el-option
              v-for="item in pzlx"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="产品条线" prop="line">
          <el-select
            v-model="addFrom.line"
            filterable
            multiple
            clearable
            style="width: 100%"
            placeholder="请选择产品条线"
          >
            <el-option
              v-for="item in line"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="被分配人" prop="ygbh">
          <treeselect
            v-model="addFrom.ygbh"
            :multiple="true"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 100%; line-height: 18px; margin-top: 4px"
            :limit="1"
            :max-height="200"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { selectDictDataByType } from "@/api/userManage";
import { saveUserManage } from "@/api/userManage.js";

export default {
  name: "add",
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      addFrom: {
        pzlx: null,
        line: null,
        ygbh: null,
      },
      rules: {
        pzlx: [
          { required: true, message: "配置类型不能为空", trigger: "change" },
        ],
        line: [
          { required: true, message: "产品条线不能为空", trigger: "blur" },
        ],
        ygbh: [
          { required: true, message: "被分配人不能为空", trigger: "change" },
        ],
      },
      pzlx: [],
      line: [],
      ygbh: [],
      parentDialog: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.$store.dispatch("common/fetchUserInfoAction");
    this.select();
  },
  methods: {
    select() {
      selectDictDataByType("pmp_quality_line", 1).then((res) => {
        if (res.code == 0) {
          this.line = res.data;
        }
      });
      selectDictDataByType("pmp_rypz_lx", 1).then((res) => {
        if (res.code == 0) {
          this.pzlx = res.data;
        }
      });
    },

    handleChangeRlsh(e) {
      this.addFrom.isReview = e;
    },
    handleChangeDrel(e) {
      this.addFrom.isMultiple = e;
    },
    handleAdd() {
      let ygbh = this.addFrom.ygbh;
      if (this.addFrom.ygbh == null) {
        this.$message({
          message: "分配人不能为空",
          type: "error",
        });
        return;
      }
      ygbh = ygbh.toString();
      let line = this.addFrom.line;
      line = line.toString();
      const params = { ...this.addFrom, ygbh, line };
      saveUserManage(params).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 55px;
}
.table {
  .table-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    > div {
      width: 20%;
      display: flex;
      justify-content: center;
      > div {
        color: #036eb8;
        padding: 0 10px;
        font-size: 25px;
        cursor: pointer;
      }
    }
    > div:nth-of-type(2) {
      width: 40%;
    }
  }
  .table-none {
    text-align: center;
    color: #999;
    margin: 10px 0;
  }
  .table-body {
    .table-tr {
      display: flex;
      height: 44px;
      line-height: 44px;
      text-align: center;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #f2f2f2;
      // border-left: 1px solid #f2f2f2;
      .table-td {
        display: flex;
        justify-content: center;
        width: 20%;
        // border-right: 1px solid #f2f2f2;
      }
      .table-td:nth-of-type(2) {
        width: 40%;
      }
      .del {
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
</style>